import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BusinessentityComponent } from './businessentity.component';
import { ReportingGuard } from 'src/app/guards/reporting.guard';
import { AddComponentBusinessentity } from './add/add.component';
import { EditComponentBusinessentity } from './edit/edit.component';
import { MembersComponent } from './members/members.component';
import { EditMembersComponent } from './members/edit/edit.component';
import { AddMemberComponent } from './members/add/add.component';



const routes: Routes = [
  {
    path: '',
    component: BusinessentityComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'add',
    component: AddComponentBusinessentity,
    canActivate: [ReportingGuard]
  },
  {
    path: 'edit/:id',
    component: EditComponentBusinessentity,
    canActivate: [ReportingGuard]
  },
  {
    path: 'members/:id',
    component: MembersComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'edit/:id/edit/:memberid',
    component: EditMembersComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'members/:id/edit/:memberid',
    component: EditMembersComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'edit/:id/add',
    component: AddMemberComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'members/:id/add',
    component: AddMemberComponent,
    canActivate: [ReportingGuard]
  },
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule],
})
export class BusinessentityModule { }
